import React from 'react';

import { withScene } from 'react-babylonjs';

// port from https://github.com/brianzinn/react-babylonjs/blob/master/stories/babylonjs/ScaledModelWithProgress.js


const ScaledModel = (props) => {
  const handleModelLoaded = (model) => {
    if (props.onModelLoaded) {
      props.onModelLoaded(model, props.sceneContext);
    }
  };
  return (
    <>
      <model
        scaleToDimension={props.scaleTo}
        onModelLoaded={(model) => handleModelLoaded(model)}
        position={props.center}
        rootUrl={props.rootUrl}
        sceneFilename={props.sceneFilename}
        pluginExtension={props.fileExtension}
        rotation={props.modelRotation}
      />
    </>
  );
};

export default withScene(ScaledModel);
